import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import Base from '../../_config/base';

class Testimonials extends Base {
  constructor(el) {
    super(el);
    const slider = el.querySelector('.testimonials__swiper');

    const sliderOpt = {
      // configure Swiper to use modules
      modules: [Navigation, Pagination],
      // centeredSlides: true,
      effect: 'fade',
      speed: 500,
      longSwipes: true,
      slidesPerView: 1,
      autoHeight: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      // Navigation arrows
      navigation: {
        nextEl: '.testimonials-swiper-button-next',
        prevEl: '.testimonials-swiper-button-prev',
      },
    };

    // eslint-disable-next-line
    const swiper = new Swiper(slider, sliderOpt);
  }
}

Testimonials.className = 'Testimonials';
export default Testimonials;
